






















































































































































































































import {
  defineComponent,
  computed,
  ref,
  onBeforeMount,
} from '@vue/composition-api';
// TODO: Vue3＋Vuex4/VueRouter4にアップデート後に、useStoreに置き換える
import { useRoute } from '@/hooks/useRoute';
import { useStore } from '@/hooks/useStore';
import { Ability } from '@/models/apis/user/userResponse';
import { UserGetterTypes } from '@/store/modules/user';
import * as ABILITY from '@/consts/ability';
import { isQualifiedForGeneralPage, hasMessageBoardAbility } from '@/lib/abilityHelper';
import { EXTERNAL_REPORT_ABILITY_DRIVER } from '@/consts/externalReports/external_reports';
import type { ExternalReportSettings } from '@/models/apis/externalReports/external_report_settings';
import type { ExternalReportAbility } from '@/models/externalReports/externalReportAbility';
import { waitForMasters } from '@/lib/masterHelper';
import { isJohaisetsuRoleDefaultUser } from '@/lib/johaisetsu/johaisetsuCommonUtil';
import { useLogout } from '@/composables/useLogout';

export default defineComponent({
  name: 'global-header',
  setup() {
    const store = useStore();
    const { route } = useRoute();
    const userState = store.state.user;
    const navbarCollapse = ref<HTMLElement>();
    const navbarDropdownMenu1 = ref<HTMLElement>();
    const navbarDropdownMenu1Sub = ref<HTMLElement>();

    const displayName = computed<string>(() => userState.display_name);
    const username = computed<string>(() => {
      return userState.username;
    });
    const isAdmin = computed<boolean>(() => {
      return userState.has_role_department_admin;
    });
    const isSuperAdmin = computed<boolean>(() => {
      return userState.has_role_super_admin;
    });
    const johaisetsuRole = computed<string>(() => {
      return userState.johaisetsu_role;
    });
    const abilityMap = computed<Record<number, Ability>>(() => {
      return userState.abilityMap;
    });
    const isLoggedIn = computed<boolean>(() => {
      return store.getters[UserGetterTypes.IS_LOGGED_IN];
    });
    const routeName = computed<string>(() => {
      return route.value.name || '';
    });
    const routePath = computed<string>(() => {
      return route.value.path || '';
    });
    const logoRouteName = computed<string>(() => {
      return isQualifiedForGeneralPage(userState) ? 'Top' : '';
    });
    const isAdminPageGroup = computed<boolean>(() => {
      return (route.value?.name || '').indexOf('Admin') === 0;
    });
    const isDevDebugPageGroup = computed<boolean>(() => {
      return (route.value?.name || '').indexOf('DevDebug') === 0;
    });
    const canUseJohaisetsuKanri = computed<boolean>(() => {
      const hasAbilityOtherThanJohaisetsu = Object.keys(abilityMap.value).some(key => {
        return parseInt(key) !== ABILITY.ABILITY_MESSAGE_BOARD;
      });
      return johaisetsuRole.value !== null && hasAbilityOtherThanJohaisetsu;
    });
    const isJohaisetsuKanriRoleHonsha = computed<boolean>(() => {
      return johaisetsuRole.value === 'honsha';
    });
    const isJohaisetsuKanriRoleKyoku = computed<boolean>(() => {
      return ['t-east', 't-west', 'kanagawa'].includes(johaisetsuRole.value);
    });
    const canUseJohaisetsuEnsuiJutenKaradanpuInput = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_ENSUI_JUTEN_KARADANPU_INPUT];
    });
    const canUseJohaisetsuEnsuiJutenKaradanpuMap = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_ENSUI_JUTEN_KARADANPU_MAP];
    });
    const canUseJohaisetsuSekisetsuInput = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_SEKISETSU_INPUT];
    });
    const canUseJohaisetsuHaisetsuKeisanInput = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_HAISETSU_KEISAN_INPUT];
    });
    const canUseJohaisetsuProgressTable = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_PROGRESS_TABLE];
    });
    const canUseJohaisetsuSagyouJoukyouInput = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_SAGYOU_JOUKYOU_INPUT];
    });
    const canUseJohaisetsuSagyouJoukyouMap = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_SAGYOU_JOUKYOU_MAP];
    });
    const canUseJohaisetsuSettouPatrolReportList = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_SETTOU_REPORT_LIST];
    });
    const canUseJohaisetsuEnsuiPlantStockTable = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_ENSUI_PLANT_STOCK_TABLE];
    });
    const canJohaisetsuMessageBoard = computed<boolean>(() => {
      return hasMessageBoardAbility(userState);
    });
    const canUseJohaisetsuMap = computed<boolean>(() => {
      return isJohaisetsuRoleDefaultUser(userState.johaisetsu_role);
    });
    const externalReportSettings = ref<ExternalReportSettings[] | null>(null);
    const externalReportAbilities = computed<ExternalReportAbility[] | null>(() => {
      return userState?.external_report_abilities ?? null;
    });
    const canUseExternalReports = computed<boolean>(() => {
      if (!externalReportAbilities.value || externalReportAbilities.value.length === 0) return false;
      if (!externalReportSettings.value || externalReportSettings.value.length === 0) return false;

      return true;
    });
    const canUseJohaisetsuWork = computed<boolean>(() => {
      return canUseJohaisetsuEnsuiJutenKaradanpuInput.value ||
        canUseJohaisetsuEnsuiJutenKaradanpuMap.value;
    });
    const useJohaisetsuOnly = computed<boolean>(() => {
      return userState.use_johaisetsu_only;
    });
    const canUseCleaningMap = computed<boolean>(() => {
      return !!abilityMap.value[ABILITY.ABILITY_CLEANING_MAP];
    });
    const useCleaningOnly = computed<boolean>(() => {
      return userState.use_cleaning_only;
    });
    const useExternalReportOnly = computed<boolean>(() =>
      !!userState.external_report_abilities?.some(ability => ability.use_this_external_report_only),
    );
    const useSpecificFunctionalityOnly = computed<boolean>(() => {
      return useJohaisetsuOnly.value || useCleaningOnly.value || useExternalReportOnly.value;
    });
    const canUseWeatherObservatoryDataPointsTable = computed<boolean>(() => {
      return userState.settings.can_use_weather_observatory;
    });
    const isActiveJohaisetsuKanri = computed<boolean>(() => {
      if (routeName.value === 'JohaisetsuMap') return false;
      return routeName.value.startsWith('Johaisetsu') ||
        routeName.value.startsWith('SettouPatrolReport') ||
        routeName.value === 'EnsuiPlantStockTable' ||
        routeName.value === 'WeatherObservatoryDataPointsTable';
    });

    const onNavVarClick = (evt: Event) => {
      // 押されたら閉じる
      const target = evt.target as HTMLElement;
      const classList = target.classList;
      if (
        (classList.contains('nav-link') || classList.contains('dropdown-item')) &&
        !classList.contains('dropdown-toggle')
      ) {
        if (navbarCollapse.value) {
          $(navbarCollapse.value).collapse('hide');
        }
        if (navbarDropdownMenu1.value) {
          $(navbarDropdownMenu1.value).removeClass('show');
        }
        if (navbarDropdownMenu1Sub.value) {
          navbarDropdownMenu1Sub.value.style.display = 'none';
        }
      }
    };
    const canUseExternalReportType = (externalReportType: string): boolean => {
      if (!externalReportAbilities.value || !externalReportSettings.value) return false;

      const externalReportSetting = externalReportSettings.value.find(
        setting => setting.external_report_type === externalReportType,
      );
      const externalReportAbility = externalReportAbilities.value.find(
        ability => ability.external_report_type === externalReportType,
      );
      if (!externalReportSetting || !externalReportAbility) return false;

      const abilities = externalReportSetting?.choices.abilities;
      const ability = abilities?.find(ability => ability.key === externalReportAbility.ability_id);
      if (!ability) return false;

      return !ability.name.endsWith(EXTERNAL_REPORT_ABILITY_DRIVER);
    };
    const subMenuOnclick = (e: Event) => {
      const element = e.target as HTMLElement;
      if (element) {
        $(element).next('div').toggle();
      }
      e.stopPropagation();
      e.preventDefault();
    };
    const { logout } = useLogout();

    onBeforeMount(async() => {
      await waitForMasters(userState);
      externalReportSettings.value = window.master?.externalReportSettings ?? null;
    });

    return {
      navbarCollapse,
      navbarDropdownMenu1,
      navbarDropdownMenu1Sub,
      // computed
      username,
      displayName,
      isAdmin,
      isSuperAdmin,
      johaisetsuRole,
      abilityMap,
      isLoggedIn,
      routeName,
      routePath,
      logoRouteName,
      isAdminPageGroup,
      isDevDebugPageGroup,
      canUseJohaisetsuKanri,
      isJohaisetsuKanriRoleHonsha,
      isJohaisetsuKanriRoleKyoku,
      canUseJohaisetsuEnsuiJutenKaradanpuInput,
      canUseJohaisetsuEnsuiJutenKaradanpuMap,
      canUseJohaisetsuSekisetsuInput,
      canUseJohaisetsuHaisetsuKeisanInput,
      canUseJohaisetsuProgressTable,
      canUseJohaisetsuSagyouJoukyouInput,
      canUseJohaisetsuSagyouJoukyouMap,
      canUseJohaisetsuSettouPatrolReportList,
      canUseJohaisetsuEnsuiPlantStockTable,
      canUseJohaisetsuMap,
      canUseJohaisetsuWork,
      canUseWeatherObservatoryDataPointsTable,
      canJohaisetsuMessageBoard,
      canUseExternalReports,
      canUseCleaningMap,
      useSpecificFunctionalityOnly,
      isActiveJohaisetsuKanri,
      externalReportSettings,
      // mothods
      canUseExternalReportType,
      onNavVarClick,
      subMenuOnclick,
      logout,
    };
  },
});
